import { Link, NavLink, useLocation } from 'react-router-dom';

import { clsx } from 'clsx';

import { Select } from '../../../shared/ui/select';

import { useIntl } from 'react-intl';

import { Logo } from '../../../shared/ui/logo';
import { ArrowRight } from 'lucide-react';

import styles from './styles.module.css';

export const NavBarView = () => {
	const { pathname } = useLocation();

	const intl = useIntl();
	const isRegisterActive = pathname.startsWith('/sign-up');
	const isLoginActive = pathname.startsWith('/sign-in');

	return (
		<header className={styles.header}>
			<div className={styles.container}>
				<Logo className={styles.logo} />

				<nav className={styles.nav}>
					<NavLink
						to='/'
						className={({ isActive }) =>
							isActive ? `${styles.navLink} ${styles.active}` : styles.navLink
						}
					>
						{intl.formatMessage({ id: 'navBarId5' })}
					</NavLink>

					<NavLink
						to='/about'
						className={({ isActive }) =>
							isActive ? `${styles.navLink} ${styles.active}` : styles.navLink
						}
					>
						{intl.formatMessage({ id: 'navBarId1' })}
					</NavLink>

					<NavLink
						to='/contact'
						className={({ isActive }) =>
							isActive ? `${styles.navLink} ${styles.active}` : styles.navLink
						}
					>
						{intl.formatMessage({ id: 'navBarId2' })}
					</NavLink>
				</nav>

				<Select />

				<div className={styles.linkToRegister}>
					<div
						className={clsx(
							styles.authGroup,
							(isRegisterActive || isLoginActive) && styles.authGroupSelected,
						)}
					>
						<Link
							to='/sign-up'
							aria-current={isRegisterActive ?? 'page'}
							className={clsx(
								styles.signUpButton,
								isRegisterActive && styles.activeButton,
							)}
						>
							{intl.formatMessage({ id: 'navBarId3' })}
						</Link>

						<span className={styles.authDivider} aria-hidden />

						<Link
							to='/sign-in'
							aria-current={isLoginActive ? 'page' : undefined}
							className={clsx(styles.loginButton, {
								[styles.activeButton]: isLoginActive,
								[styles.loginPrimary]: !isLoginActive && !isRegisterActive,
							})}
						>
							{intl.formatMessage({ id: 'navBarId4' })}
							<ArrowRight size={16} strokeWidth={2.25} aria-hidden />
						</Link>
					</div>
				</div>
			</div>
		</header>
	);
};
